import React, { Component } from 'react';

class AboutGolf extends Component {
  render() {
    return (
      <section className={this.props.background} id="about">
        <div className="container mt-4 mb-4">
          <div className="row pt-5 pb-5">
            <span className="col-12 txt-bold-40px txt-red">Resto-BAR</span>
            <span className="col-12 txt-thin">
              Au cœur d'un des plus beaux endroits à Sousse, Golf Brau vous accueille dans un cadre à la fois convivial et
              élégant, et un concept novateur d'un resto-bar artistique, chaleureux chic et festif.
            </span>
          </div>
        </div>
      </section>
    );
  }
}

export default AboutGolf;



// WEBPACK FOOTER //
// ./src/components/golf/AboutGolf.js